/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter 
} from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Switch } from './ui/switch';
import {
  Package, Plus, Edit3, Trash2, Copy, Users, CreditCard, Wallet, Coins,
  TrendingUp, Shield, Building, Briefcase, Eye, UserPlus, Check, X,
  Loader2, Search, Filter, BarChart3, Settings, Zap, Star, Crown,
  ChevronRight, ArrowRight, Sparkles, Target, Award, Clock, Calendar,
  PieChart, Activity, Info, AlertCircle, CheckCircle2, RefreshCw, ShoppingCart, Receipt
} from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import StripeCheckoutButton from './StripeCheckoutButton';
import { getToken, getAuthHeader as getStoredAuthHeader } from '../services/tokenService';
import InstitutionalHero from './ui/InstitutionalHero';


export const GestionPlansDetailDialog = ({ ctx }) => {
  const {
    activeTab, assignForm, assignPlanSearch, assignUserSearch, assignmentSearch,
    assignmentStatusFilter, assignments, dialogStep, editingPlan, filterRole, filterType,
    loading, planForm, plans, saving, searchTerm, selectedPlan, selectedPlanIds,
    showAssignDialog, showDetailDialog, showPlanDialog, users,
    setActiveTab, setAssignForm, setAssignPlanSearch, setAssignUserSearch, setAssignmentSearch,
    setAssignmentStatusFilter, setAssignments, setDialogStep, setEditingPlan, setFilterRole,
    setFilterType, setLoading, setPlanForm, setPlans, setSaving, setSearchTerm, setSelectedPlan,
    setSelectedPlanIds, setShowAssignDialog, setShowDetailDialog, setShowPlanDialog, setUsers,
    fetchAssignments, fetchPlans, fetchUsers, filteredPlans, getAuthHeader, getPricingTypeConfig,
    getRoleConfig, handleAssignPlan, handleBulkDeletePlans, handleBulkToggleActive, handleDeletePlan,
    handleDuplicatePlan, handleSavePlan, openCreateDialog, openDetailDialog, openEditDialog,
    renderPlanPrice, stats, togglePlanSelection, toggleSelectAllPlans,
    PRICING_TYPES, TARGET_ROLES, DEFAULT_PLAN, PLAN_COLORS, getErrorMessage,
  } = ctx;
  return (
      <Dialog open={showDetailDialog} onOpenChange={setShowDetailDialog}>
        <DialogContent className="max-w-lg">
          {selectedPlan && (
            <>
              <DialogHeader className="border-b pb-4">
                <div className="flex items-center gap-4">
                  <div 
                    className="p-3 rounded-xl"
                    style={{ backgroundColor: `${selectedPlan.couleur}20` }}
                  >
                    <Package className="h-6 w-6" style={{ color: selectedPlan.couleur }} />
                  </div>
                  <div>
                    <DialogTitle className="text-xl">{selectedPlan.nom}</DialogTitle>
                    <Badge 
                      variant="outline" 
                      className={`mt-1 ${getPricingTypeConfig(selectedPlan.type_tarification).bg} ${getPricingTypeConfig(selectedPlan.type_tarification).text} border-0`}
                    >
                      {getPricingTypeConfig(selectedPlan.type_tarification).label}
                    </Badge>
                  </div>
                </div>
              </DialogHeader>
              
              <div className="space-y-4 py-4">
                {selectedPlan.description && (
                  <p className="text-gray-600">{selectedPlan.description}</p>
                )}
                
                <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                  <h4 className="font-semibold text-gray-700">Tarification</h4>
                  <div className="grid grid-cols-2 gap-3">
                    {selectedPlan.pricing?.prix_mensuel > 0 && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Mensuel</span>
                        <span className="font-bold">{selectedPlan.pricing.prix_mensuel}€</span>
                      </div>
                    )}
                    {selectedPlan.pricing?.prix_annuel > 0 && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Annuel</span>
                        <span className="font-bold">{selectedPlan.pricing.prix_annuel}€</span>
                      </div>
                    )}
                    {selectedPlan.pricing?.credits_inclus > 0 && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Crédits</span>
                        <span className="font-bold">{selectedPlan.pricing.credits_inclus}</span>
                      </div>
                    )}
                  </div>
                </div>
                
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Rôles cibles</h4>
                  <div className="flex flex-wrap gap-2">
                    {(selectedPlan.roles_cibles || []).map((role) => {
                      const roleConfig = getRoleConfig(role);
                      const RoleIcon = roleConfig.icon;
                      return (
                        <Badge key={role} className={`${roleConfig.bg} ${roleConfig.text} border-0`}>
                          <RoleIcon className="h-3 w-3 mr-1" />
                          {roleConfig.label}
                        </Badge>
                      );
                    })}
                  </div>
                </div>
                
                <div className="flex items-center justify-between pt-3 border-t">
                  <div className="flex items-center gap-2">
                    <Users className="h-4 w-4 text-gray-400" />
                    <span className="text-gray-600">{selectedPlan.subscribers_count || 0} abonné(s)</span>
                  </div>
                  <Badge className={selectedPlan.is_active ? 'bg-emerald-600 text-white' : 'bg-gray-600 text-white'}>
                    {selectedPlan.is_active ? 'Actif' : 'Inactif'}
                  </Badge>
                </div>
              </div>
              
              <DialogFooter className="border-t pt-4">
                <Button variant="outline" onClick={() => setShowDetailDialog(false)}>
                  Fermer
                </Button>
                <Button onClick={() => { setShowDetailDialog(false); openEditDialog(selectedPlan); }} className="bg-purple-600 hover:bg-purple-700">
                  <Edit3 className="h-4 w-4 mr-2" />
                  Modifier
                </Button>
              </DialogFooter>
            </>
          )}
        </DialogContent>
      </Dialog>
  );
};

export default GestionPlansDetailDialog;
